const repoInfo = {
  githubUsername: "JoshBergman",
  avatarUrl: "https://avatars.githubusercontent.com/u/111944876?v=4",
};

export default repoInfo;
